import { Box, styled } from "@mui/material";
import { IStyledBoxCardProps } from "./types";

const StyledBoxCard = styled(Box)<IStyledBoxCardProps>(({ theme }) => ({
    backgroundColor: (theme as any).palette.neutral.darkest,
    padding: theme.spacing(3),
    boxSizing: 'border-box',
    borderRadius: (theme as any).shape.border.general.radius[9],
}))

export { StyledBoxCard }